import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { ErrorObject, PopupDialogAction, PopupDialogObject, PopupDialogOptions } from '../../models';
import { AbstractErrorHandlerService } from '../abstract-error-handler.service';
import { ErrorHelperService } from '../error-helper.service';
import { ErrorPopupService } from '../error-popup.service';

@Injectable()
export class PasModelAnalyticsErrorHandlerService extends AbstractErrorHandlerService {
	private flagErrorConfigs = ['familyPerformance', 'familyOverview'];

	constructor(
		public contentService: ContentService,
		public errorPopupService: ErrorPopupService,
		public tealiumAnalyticsService: TealiumAnalyticsService,
		public errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		const configName = get(error, 'configName', '');
		if (error instanceof ErrorObject && this.flagErrorConfigs.includes(configName)) {
			const action_continue = [
				PopupDialogAction.create({
					label: this.contentService.get('ERROR_CONTINUE_LABEL', ErrorDCR.ERROR_CONTINUE_LABEL),
					type: 'continue',
					reload: false
				})
			];
			this.trackErrorMessage = error?.responseJson?.message;
			this.errorSeverity = ERROR_SEVERITY.WARNING;
			const dialogTitleDCRKey = 'PAS_MODEL_ANALYTICS_ERROR_TITLE';
			const dialogDescriptionDCRKey = 'PAS_MODEL_ANALYTICS_ERROR_DESCRIPTION';
			const failedMessage = PopupDialogObject.create({
				success: false,
				title: this.contentService.get(dialogTitleDCRKey, 'Invalid API response for selected models'),
				description: this.contentService.get(dialogDescriptionDCRKey, `${this.trackErrorMessage}`),
				actions: action_continue
			} as PopupDialogOptions);
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			this.errorPopupService.openResponseMessageDialog(failedMessage, true, '730px', 'md', false);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
